import CourseWorkCycleAvailableContainer from './CourseWorkCycleAvailableContainer';

export default CourseWorkCycleAvailableContainer;